'use client'

import Link from 'next/link'
import type { ComponentProps } from 'react'

import { useHoverPrefetch } from '@/app/@protected/_hooks/use-hover-prefetch.ts'

type PrefetchLinkProps = Omit<ComponentProps<typeof Link>, 'href' | 'prefetch'> & { href: string }

/**
 * A link that fully prefetches its route when the pointer reaches it, so the click opens the page
 * rather than its loading.tsx. It never prefetches on entering the viewport: in Next 16.4.3 that
 * prefetch stops at loading.tsx, and a full prefetch within the next 10 s lands where navigation
 * never reads it (see `RowDetailsLink`).
 */
export const PrefetchLink = ({ onMouseEnter, ...props }: PrefetchLinkProps) => {
  const prefetch = useHoverPrefetch()

  return (
    <Link
      {...props}
      onMouseEnter={event => {
        prefetch(props.href)
        onMouseEnter?.(event)
      }}
      prefetch={false}
    data-sentry-element="Link" data-sentry-component="PrefetchLink" data-sentry-source-file="prefetch-link.tsx" />
  )
}
